import React, {useLayoutEffect, useState, useContext} from 'react';
import styled from "styled-components";

import useFetch from "../Utilities/API/useFetch.react";
import {StyledForeground} from "../Components/Commons/StyledForeground.react";
import TBSelect from "../Components/Commons/TBSelect.react";
import {Button, Modal, Select} from "react-materialize";

import {StyledTable, TableCell, TableHeader, TableRow} from "../Components/Commons/TBTable.react";

const MOCK_REPORTS = ['New Customers', 'Total Transactions', 'Revenue']

const StyledReportsPage = styled.div`
  padding-top: 2rem;
  height: 100%;
  width: 100%;
  h1 {
    font-size: 3rem;
    font-weight: 400;
    letter-spacing: 1px;
    color: white;
    padding-left: 2rem;
    padding-top: 2rem;
  }
  
  .report-selection {
    border: 1px solid lightgrey;
    margin-top: 4rem;
    margin-left: 2rem;
    margin-right: 2rem;
    padding: 2rem;
    background-color: #FFFFFF;
    min-height: 30rem;
  }
  
  .custom-report {
    padding: 2rem;
    
    h2 {
      font-size: 3rem;
      font-weight: 400;
      letter-spacing: 1px;
      color: #575757;
    }
    
    .query-section {
      padding: 2rem;
      min-height: 25rem;
      
      .help-text {
        font-size: 1.5rem;
        margin-bottom: 1rem;
        color: #575757;
      }

      .query-select {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1rem;
      }
      
      .filter-button {
        margin-left: 1rem;
        height: 4.1rem;
      }
      
      .clear {
        background-color: #DFE0E0;
        color: black;
        width: 17rem;
      }
    }
    
  }
`

const StyledTextarea = styled.textarea`
  border: 1px solid #E2E5E8;
  height: 100%;
  color: #515151;
`

const ReportsPage = () => {
  const [fetchUrl] = useFetch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reports, setReports] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [selectParam, setSelectParam] = useState(null);

  const [customReportHeaders, setHeaders] = useState([]);
  const [customReport, setCustomReport] = useState([]);
  const [customQuery, setCustomQuery] = useState('');

  useLayoutEffect(() => {
    fetchUrl('fetchReports').then((response) => {
      setReports(response);
    }).catch((error) => {
      console.log('error =>', error);
    })
  }, [])


  const handleReportSelect = (report) => {
    if (report.length < 1) {
      setSelectedReport(null);
      setSelectParam(null)
    } else {
      setSelectedReport(report);
      setSelectParam(report.parameters[0].options[0])
    }
  }

  const handleParamSelect = (option) => {
    if (option.length < 1) {
      setSelectParam(null);
    } else {
      setSelectParam(option);
    }
  }


  const downloadSelectedRun = (report) => {
    if (selectedReport && selectParam) {
      setLoading(true);
      fetchUrl("downloadCannedReport", {reportId: selectParam.value}).then((response) => {
        let url = response.downloadUrl
        downloadUrl(url)
      }).catch((error) => {
        setError(error);
      }).finally(() => {
        setLoading(false);
      })
      //???
    } else {
      //???
    }
  }

  const downloadUrl = (url) => {
    const a = document.createElement("a")
    a.href = url
    a.click()
  }

  const handleCustomReport = () => {
    setLoading('CUSTOM_REPORT_LOADING');
    fetchUrl("runCustomReport", {query: customQuery}).then((response) => {
      if (response.data && response.data.length > 0) {
        let customQueryData = response.data;
        let firstRow = customQueryData[0];
        let reportHeaders = Object.keys(firstRow);
        setHeaders(reportHeaders);
        setCustomReport(customQueryData);
      }
    }).catch((error) => {
      setError(error);
    }).finally(() => {
      setLoading(false);
    })
  }

  const handleCustomChange = (event) => {
    setCustomQuery(event.target.value);
  }

  const handleClear = () => {
    setCustomReport([]);
    setHeaders([]);
    setCustomQuery('');
  }

  const maybeOptions = selectedReport ?  selectedReport.parameters[0].options.map(x => {
    x.name = x.label
    return x
  }): [] ;

  console.log(maybeOptions)
  return (
    <StyledReportsPage>
      <StyledForeground />
      <header>
        <h1>Reports</h1>
      </header>
      <div className={'report-selection'}>
        <p>Select a Journal Entry to Download</p>
        <TBSelect handleSelect={handleReportSelect} selectWidth={'100%'} label={'Reports'} listItems={reports} />
        {selectedReport ? 
          <div>
            <TBSelect label={"Select Option"} handleSelect={handleParamSelect} selectWidth={'100%'} listItems={maybeOptions} />
          </div> : 
          <div></div>}
        <Button onClick={downloadSelectedRun} className={'filter-button'} node='button'>Download</Button>

      </div>
      {/*<div className={'custom-report'}>*/}
      {/*  <h2>Custom Report</h2>*/}
      {/*  <div className={'query-section'}>*/}
      {/*    <p className={'help-text'}>Use SQL to create a custom report</p>*/}
      {/*    <div className={'query-select'}>*/}
      {/*      <StyledTextarea value={customQuery} onChange={handleCustomChange} />*/}
      {/*      <Button onClick={handleCustomReport} className={'filter-button'} node='button'>Run</Button>*/}
      {/*      {customReport.length > 0 && <Button onClick={handleClear} className={'filter-button clear'} node='button'>Clear Report</Button>}*/}
      {/*    </div>*/}
      {/*    <div>*/}
      {/*      <StyledTable>*/}
      {/*        <TableHeader>*/}
      {/*        {*/}
      {/*          customReportHeaders.length > 0 && customReportHeaders.map((header, index) => {*/}
      {/*            return <th key={`${header}-${index}`}>{header}</th>*/}
      {/*          })*/}
      {/*        }*/}
      {/*        </TableHeader>*/}
      {/*        {*/}
      {/*          customReport.length > 0 && customReport.map((row, index) => {*/}
      {/*            return (*/}
      {/*              <TableRow key={index} index={index}>*/}
      {/*                {*/}
      {/*                  customReportHeaders.map((columnKey) => {*/}
      {/*                    let data = row[columnKey]*/}
      {/*                    return <TableCell><p>{data}</p></TableCell>*/}
      {/*                  })*/}
      {/*                }*/}
      {/*              </TableRow>*/}
      {/*            )*/}
      {/*          })*/}
      {/*        }*/}
      {/*      </StyledTable>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </StyledReportsPage>
  )
}

export default ReportsPage;